import gsap from 'gsap'
import Plyr from 'plyr'

import BaseComponent from './_BaseComponent'




/* STORY VIDEO PLAYER
----------------------------------------------------------------------------------------------------*/

export default class StoryVideo extends BaseComponent {

    constructor($el, namespace) {
        super('StoryVideo', $el, namespace)

        this.isPlaying = false

        this.initPlayer()
        this.on()
    }


    bindHandlers() {
        this.pageWillChangeHandler = () => { this.onPageWillChange() }
        this.keydownHandler  = (e) => { this.onKeydown(e) }
        this.clickHandler = (e) => { this.onPlayButtonClick(e) }
        this.clickOutsideHandler = (e) => { this.onClickOutside(e) }
        this.closeClickHandler = e => this.onCloseClick(e)
    }


    bindEvents() {
        const { $playBtn, $closeBtn } = this.$refs


        this.addListeners(
            // User input
            [$playBtn, 'click', this.clickHandler],
            [$closeBtn, 'click', this.closeClickHandler],

            // Nav events
            [document, 'pageWillChange', this.pageWillChangeHandler],
        )
    }




    /* Handlers
    --------------------------------------------------------- */

    onPlayButtonClick(e) {
        e.preventDefault()

        this.toggle(true)
    }


    onClickOutside({ target }) {
        if (target.closest('.js-Video-playerCtn')
            || target.closest('.js-Video-playBtn')
            || target.closest('.plyr')
            || !this.isPlaying) return

        this.toggle(false)
    }


    onCloseClick(e) {
        e.preventDefault()

        this.toggle(false)
    }


    onKeydown(e) {
        // Escape
        if (e.keyCode === 27) {
            this.toggle(false)
        }
    }


    onPageWillChange() {
        this.toggle(false)
    }




    /* Init
    --------------------------------------------------------- */

    initPlayer() {
        // if (!APP.CookieConsent.hasAccepted('functional')) return

        this.$refs.$playBtn.removeAttr('disabled')
        this.$el.removeClass('is-unplayable')

        const options = {
            ratio: '16:9',
            controls: ['play', 'progress', 'current-time', 'duration', 'mute', 'volume'],
            resetOnEnd: true,
            quality: { default: 1080 },
            fullscreen: {
                enabled: false,
            },
            keyboard: {
                global: true,
            },
            youtube: {
                noCookie: true,
                rel: 0,
                showInfo: 0,
                cc_load_policy: 1,
                cc_lang_pref: document.documentElement.getAttribute('lang'),
            },
        }

        this.Player = new Plyr(this.$refs.$playerCtn[0], options)
    }




    /* Actions
    --------------------------------------------------------- */

    toggle(shouldPlay = !this.isPlaying) {
        if (shouldPlay === this.isPlaying) return

        const { $doc } = this.$utils
        this.isPlaying = shouldPlay


        if (shouldPlay) {
            this.Player.play()
            this.bindListener($doc, 'keydown', this.keydownHandler)
        } else {
            this.Player.pause()
            this.unbindListener($doc, 'keydown', this.keydownHandler)
        }

        this.$el.toggleClass('is-playing', shouldPlay)
        $doc.trigger('overlayToggled', { isOpen : shouldPlay })
    }


}



